import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricingRegion } from '../contexts/PricingRegionContext';
import { getWhatsAppLink } from '../config/contact';

const FloatingWhatsApp = () => {
  const { t, isRTL } = useLanguage();
  const { pricingRegion } = usePricingRegion();
  const message = [
    t('form.contactIntro'),
    '',
    `Pricing region: ${pricingRegion.id}`,
    `Currency: ${pricingRegion.currencyCode}`,
  ].join('\n');

  return (
    <a
      href={getWhatsAppLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('common.whatsapp')}
      className="fixed z-40 flex h-14 items-center justify-center gap-2 rounded-full border border-[#00FFD1]/25 bg-[#07110f]/90 px-4 text-[#00FFD1] shadow-[0_14px_45px_rgba(0,0,0,0.55),0_0_30px_rgba(0,255,209,0.12)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-[#00FFD1]/50 hover:bg-[#00FFD1] hover:text-black"
      style={{
        bottom: 'calc(1.25rem + env(safe-area-inset-bottom, 0px))',
        [isRTL ? 'left' : 'right']: `calc(1rem + env(safe-area-inset-${isRTL ? 'left' : 'right'}, 0px))`,
      }}
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden text-sm font-semibold sm:inline">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
